import {processAPIResponse} from "@/utils/request";
import {fetchExtraFieldTypesList} from "@/services/api/extraFieldType";

const initialState = {
  types: []
}
export default {
  namespace: 'extraFields',

  state: initialState,

  effects: {
    * fetchExtraFieldTypes(_, {call, put, select}) {
      const {response, data} = yield call(fetchExtraFieldTypesList, {
        query:{
          with_options: 1
        }
      });
      yield processAPIResponse({response, data}, {
        * onSuccess(data) {
          yield put({
            type: 'saveExtraFieldTypes',
            payload: data
          })
        }
      }, 'data')
    },
  },

  reducers: {
    saveExtraFieldTypes(state, action) {
      return {
        ...state,
        types: action.payload,
      };
    },
    reorderTypes(state, { payload: { relatedTo, order } }) {
      const orderMap = new Map(order.map((uuid: string, index: number) => [uuid, index]));
      const types = [...state.types].sort((a, b) => {
        if (a.related_to !== relatedTo || b.related_to !== relatedTo) return 0;
        return (orderMap.get(a.uuid) ?? 0) - (orderMap.get(b.uuid) ?? 0);
      });
      return { ...state, types };
    },
    reset(){
      return initialState
    }
  }
};
